module.exports = __webpack_public_path__ + "static/img/light.029a363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/light.png
// module id = dPD+
// module chunks = 2